import * as service from './service'
export default {
  namespace: 'levelSysFinishYears',
  state: {
    workingYearsData: {
      workingTime: {}
    }
  },
  effects: {
    * workingYears ({ payload }, { call, put }) {
      const res = yield call(service.workingYears, payload)
      yield put({
        type: 'save',
        payload: {
          workingYearsData: res.data.data
        }
      })
    }
  },
  reducers: {
    save (state, { payload }) {
      return { ...state, ...payload }
    }
  }
}
